// source: analytics-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.analyticsmanager.AccountStat', null, global);
goog.exportSymbol('proto.analyticsmanager.AccountStatsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.AccountStatsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.AccountTicket', null, global);
goog.exportSymbol('proto.analyticsmanager.AccountsOverviewStatsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.AccountsOverviewStatsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminGetAccountBalanceReply', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminGetAccountBalanceReq', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminListTradesReply', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminListTradesReq', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminSyncAccountReply', null, global);
goog.exportSymbol('proto.analyticsmanager.AdminSyncAccountReq', null, global);
goog.exportSymbol('proto.analyticsmanager.BalanceInfo', null, global);
goog.exportSymbol('proto.analyticsmanager.CopierMetricsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.CopierMetricsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.DateWiseData', null, global);
goog.exportSymbol('proto.analyticsmanager.DateWiseIntData', null, global);
goog.exportSymbol('proto.analyticsmanager.GetBalanceInfoReply', null, global);
goog.exportSymbol('proto.analyticsmanager.GetBalanceInfoReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntAddAnalyticsUserReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntAddAnalyticsUserReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetMasterTradesReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetMasterTradesReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetOpenTradeTicketsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetOpenTradeTicketsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTotalOpenTradesCountReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTotalOpenTradesCountReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTradeAccountStatsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTradeAccountStatsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTradeDetailsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetTradeDetailsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetUserOpenTradesCountReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntGetUserOpenTradesCountReq', null, global);
goog.exportSymbol('proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply', null, global);
goog.exportSymbol('proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq', null, global);
goog.exportSymbol('proto.analyticsmanager.ListAccountStatsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.ListAccountStatsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.ListTradesReply', null, global);
goog.exportSymbol('proto.analyticsmanager.ListTradesReq', null, global);
goog.exportSymbol('proto.analyticsmanager.MasterMeta', null, global);
goog.exportSymbol('proto.analyticsmanager.OverviewStatsReply', null, global);
goog.exportSymbol('proto.analyticsmanager.OverviewStatsReq', null, global);
goog.exportSymbol('proto.analyticsmanager.TRADE_STATUS', null, global);
goog.exportSymbol('proto.analyticsmanager.TradeDetails', null, global);
goog.exportSymbol('proto.analyticsmanager.TradeRes', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountsOverviewStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AccountsOverviewStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountsOverviewStatsReq.displayName = 'proto.analyticsmanager.AccountsOverviewStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountsOverviewStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.AccountsOverviewStatsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.AccountsOverviewStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountsOverviewStatsReply.displayName = 'proto.analyticsmanager.AccountsOverviewStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminListTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AdminListTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminListTradesReq.displayName = 'proto.analyticsmanager.AdminListTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminListTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.AdminListTradesReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.AdminListTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminListTradesReply.displayName = 'proto.analyticsmanager.AdminListTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminGetAccountBalanceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AdminGetAccountBalanceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminGetAccountBalanceReq.displayName = 'proto.analyticsmanager.AdminGetAccountBalanceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminGetAccountBalanceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AdminGetAccountBalanceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminGetAccountBalanceReply.displayName = 'proto.analyticsmanager.AdminGetAccountBalanceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetTotalOpenTradesCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTotalOpenTradesCountReq.displayName = 'proto.analyticsmanager.IntGetTotalOpenTradesCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetTotalOpenTradesCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTotalOpenTradesCountReply.displayName = 'proto.analyticsmanager.IntGetTotalOpenTradesCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetUserOpenTradesCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetUserOpenTradesCountReq.displayName = 'proto.analyticsmanager.IntGetUserOpenTradesCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetUserOpenTradesCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetUserOpenTradesCountReply.displayName = 'proto.analyticsmanager.IntGetUserOpenTradesCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.ListTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.ListTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.ListTradesReq.displayName = 'proto.analyticsmanager.ListTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.ListTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.ListTradesReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.ListTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.ListTradesReply.displayName = 'proto.analyticsmanager.ListTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.TradeRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.TradeRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.TradeRes.displayName = 'proto.analyticsmanager.TradeRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.GetBalanceInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.GetBalanceInfoReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.GetBalanceInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.GetBalanceInfoReq.displayName = 'proto.analyticsmanager.GetBalanceInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.GetBalanceInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.GetBalanceInfoReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.GetBalanceInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.GetBalanceInfoReply.displayName = 'proto.analyticsmanager.GetBalanceInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.BalanceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.BalanceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.BalanceInfo.displayName = 'proto.analyticsmanager.BalanceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AccountStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountStatsReq.displayName = 'proto.analyticsmanager.AccountStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.AccountStatsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.AccountStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountStatsReply.displayName = 'proto.analyticsmanager.AccountStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.CopierMetricsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.CopierMetricsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.CopierMetricsReq.displayName = 'proto.analyticsmanager.CopierMetricsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.CopierMetricsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.CopierMetricsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.CopierMetricsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.CopierMetricsReply.displayName = 'proto.analyticsmanager.CopierMetricsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.OverviewStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.OverviewStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.OverviewStatsReq.displayName = 'proto.analyticsmanager.OverviewStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.OverviewStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.OverviewStatsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.OverviewStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.OverviewStatsReply.displayName = 'proto.analyticsmanager.OverviewStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.DateWiseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.DateWiseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.DateWiseData.displayName = 'proto.analyticsmanager.DateWiseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.DateWiseIntData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.DateWiseIntData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.DateWiseIntData.displayName = 'proto.analyticsmanager.DateWiseIntData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.ListAccountStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.ListAccountStatsReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.ListAccountStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.ListAccountStatsReq.displayName = 'proto.analyticsmanager.ListAccountStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.ListAccountStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.ListAccountStatsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.ListAccountStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.ListAccountStatsReply.displayName = 'proto.analyticsmanager.ListAccountStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AccountStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountStat.displayName = 'proto.analyticsmanager.AccountStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntAddAnalyticsUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntAddAnalyticsUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntAddAnalyticsUserReq.displayName = 'proto.analyticsmanager.IntAddAnalyticsUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntAddAnalyticsUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntAddAnalyticsUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntAddAnalyticsUserReply.displayName = 'proto.analyticsmanager.IntAddAnalyticsUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetMasterTradesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetMasterTradesReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetMasterTradesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetMasterTradesReq.displayName = 'proto.analyticsmanager.IntGetMasterTradesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetMasterTradesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetMasterTradesReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetMasterTradesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetMasterTradesReply.displayName = 'proto.analyticsmanager.IntGetMasterTradesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AccountTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AccountTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AccountTicket.displayName = 'proto.analyticsmanager.AccountTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTradeDetailsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetTradeDetailsReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetTradeDetailsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTradeDetailsReq.displayName = 'proto.analyticsmanager.IntGetTradeDetailsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTradeDetailsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetTradeDetailsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetTradeDetailsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTradeDetailsReply.displayName = 'proto.analyticsmanager.IntGetTradeDetailsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.TradeDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.TradeDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.TradeDetails.displayName = 'proto.analyticsmanager.TradeDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetTradeAccountStatsReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetTradeAccountStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTradeAccountStatsReq.displayName = 'proto.analyticsmanager.IntGetTradeAccountStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetTradeAccountStatsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetTradeAccountStatsReply.displayName = 'proto.analyticsmanager.IntGetTradeAccountStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.displayName = 'proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.displayName = 'proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.displayName = 'proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.displayName = 'proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.MasterMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.MasterMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.MasterMeta.displayName = 'proto.analyticsmanager.MasterMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminSyncAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AdminSyncAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminSyncAccountReq.displayName = 'proto.analyticsmanager.AdminSyncAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.AdminSyncAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyticsmanager.AdminSyncAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.AdminSyncAccountReply.displayName = 'proto.analyticsmanager.AdminSyncAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetOpenTradeTicketsReq.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetOpenTradeTicketsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetOpenTradeTicketsReq.displayName = 'proto.analyticsmanager.IntGetOpenTradeTicketsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyticsmanager.IntGetOpenTradeTicketsReply.repeatedFields_, null);
};
goog.inherits(proto.analyticsmanager.IntGetOpenTradeTicketsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyticsmanager.IntGetOpenTradeTicketsReply.displayName = 'proto.analyticsmanager.IntGetOpenTradeTicketsReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountsOverviewStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountsOverviewStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReq}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountsOverviewStatsReq;
  return proto.analyticsmanager.AccountsOverviewStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReq}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountsOverviewStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountsOverviewStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReq} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReq} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.AccountsOverviewStatsReply.repeatedFields_ = [1,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountsOverviewStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountsOverviewStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsConnectedDailyList: jspb.Message.toObjectList(msg.getAccountsConnectedDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
accountsConnectedDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
activeAccountsList: jspb.Message.toObjectList(msg.getActiveAccountsList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
inactiveAccountsList: jspb.Message.toObjectList(msg.getInactiveAccountsList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
activeAccountsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
inactiveAccountsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
bestProfitPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
bestPerformingAccount: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountsOverviewStatsReply;
  return proto.analyticsmanager.AccountsOverviewStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addAccountsConnectedDaily(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccountsConnectedDiff(value);
      break;
    case 3:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addActiveAccounts(value);
      break;
    case 4:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addInactiveAccounts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setActiveAccountsDiff(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInactiveAccountsDiff(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestProfitPercentage(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBestPerformingAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountsOverviewStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountsOverviewStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountsOverviewStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsConnectedDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getAccountsConnectedDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getActiveAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getInactiveAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getActiveAccountsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getInactiveAccountsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getBestProfitPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getBestPerformingAccount();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * repeated DateWiseIntData accounts_connected_daily = 1;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getAccountsConnectedDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
*/
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setAccountsConnectedDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.addAccountsConnectedDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.clearAccountsConnectedDailyList = function() {
  return this.setAccountsConnectedDailyList([]);
};


/**
 * optional double accounts_connected_diff = 2;
 * @return {number}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getAccountsConnectedDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setAccountsConnectedDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated DateWiseIntData active_accounts = 3;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getActiveAccountsList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 3));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
*/
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setActiveAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.addActiveAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.clearActiveAccountsList = function() {
  return this.setActiveAccountsList([]);
};


/**
 * repeated DateWiseIntData inactive_accounts = 4;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getInactiveAccountsList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 4));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
*/
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setInactiveAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.addInactiveAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.clearInactiveAccountsList = function() {
  return this.setInactiveAccountsList([]);
};


/**
 * optional double active_accounts_diff = 5;
 * @return {number}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getActiveAccountsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setActiveAccountsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double inactive_accounts_diff = 6;
 * @return {number}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getInactiveAccountsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setInactiveAccountsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double best_profit_percentage = 8;
 * @return {number}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getBestProfitPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setBestProfitPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional string best_performing_account = 9;
 * @return {string}
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.getBestPerformingAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountsOverviewStatsReply} returns this
 */
proto.analyticsmanager.AccountsOverviewStatsReply.prototype.setBestPerformingAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminListTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminListTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminListTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: (f = msg.getUserId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
searchKey: (f = msg.getSearchKey()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
openTrades: (f = msg.getOpenTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
closedTrades: (f = msg.getClosedTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminListTradesReq}
 */
proto.analyticsmanager.AdminListTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminListTradesReq;
  return proto.analyticsmanager.AdminListTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminListTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminListTradesReq}
 */
proto.analyticsmanager.AdminListTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchKey(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setOpenTrades(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setClosedTrades(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminListTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminListTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminListTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSearchKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOpenTrades();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getClosedTrades();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue user_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getUserId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
*/
proto.analyticsmanager.AdminListTradesReq.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue search_key = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getSearchKey = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
*/
proto.analyticsmanager.AdminListTradesReq.prototype.setSearchKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.clearSearchKey = function() {
  return this.setSearchKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.hasSearchKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue open_trades = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getOpenTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
*/
proto.analyticsmanager.AdminListTradesReq.prototype.setOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.clearOpenTrades = function() {
  return this.setOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.hasOpenTrades = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue closed_trades = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getClosedTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
*/
proto.analyticsmanager.AdminListTradesReq.prototype.setClosedTrades = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.clearClosedTrades = function() {
  return this.setClosedTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.hasClosedTrades = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string pagination_cursor = 5;
 * @return {string}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 page_size = 6;
 * @return {number}
 */
proto.analyticsmanager.AdminListTradesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AdminListTradesReq} returns this
 */
proto.analyticsmanager.AdminListTradesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.AdminListTradesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminListTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminListTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminListTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.analyticsmanager.TradeRes.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminListTradesReply}
 */
proto.analyticsmanager.AdminListTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminListTradesReply;
  return proto.analyticsmanager.AdminListTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminListTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminListTradesReply}
 */
proto.analyticsmanager.AdminListTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.TradeRes;
      reader.readMessage(value,proto.analyticsmanager.TradeRes.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminListTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminListTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminListTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.TradeRes.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated TradeRes trades = 1;
 * @return {!Array<!proto.analyticsmanager.TradeRes>}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.analyticsmanager.TradeRes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.TradeRes, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.TradeRes>} value
 * @return {!proto.analyticsmanager.AdminListTradesReply} returns this
*/
proto.analyticsmanager.AdminListTradesReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.TradeRes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.TradeRes}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.TradeRes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AdminListTradesReply} returns this
 */
proto.analyticsmanager.AdminListTradesReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminListTradesReply} returns this
 */
proto.analyticsmanager.AdminListTradesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AdminListTradesReply} returns this
 */
proto.analyticsmanager.AdminListTradesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.analyticsmanager.AdminListTradesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AdminListTradesReply} returns this
 */
proto.analyticsmanager.AdminListTradesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminGetAccountBalanceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReq}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminGetAccountBalanceReq;
  return proto.analyticsmanager.AdminGetAccountBalanceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReq}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminGetAccountBalanceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReq} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReq} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminGetAccountBalanceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminGetAccountBalanceReply;
  return proto.analyticsmanager.AdminGetAccountBalanceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminGetAccountBalanceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminGetAccountBalanceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double equity = 3;
 * @return {number}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminGetAccountBalanceReply} returns this
 */
proto.analyticsmanager.AdminGetAccountBalanceReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTotalOpenTradesCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTotalOpenTradesCountReq}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTotalOpenTradesCountReq;
  return proto.analyticsmanager.IntGetTotalOpenTradesCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTotalOpenTradesCountReq}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTotalOpenTradesCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTotalOpenTradesCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTotalOpenTradesCountReply;
  return proto.analyticsmanager.IntGetTotalOpenTradesCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTotalOpenTradesCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 count = 1;
 * @return {number}
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.IntGetTotalOpenTradesCountReply} returns this
 */
proto.analyticsmanager.IntGetTotalOpenTradesCountReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetUserOpenTradesCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReq}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetUserOpenTradesCountReq;
  return proto.analyticsmanager.IntGetUserOpenTradesCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReq}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetUserOpenTradesCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReq} returns this
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetUserOpenTradesCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
openTrades: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReply}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetUserOpenTradesCountReply;
  return proto.analyticsmanager.IntGetUserOpenTradesCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReply}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetUserOpenTradesCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetUserOpenTradesCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpenTrades();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 open_trades = 1;
 * @return {number}
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.prototype.getOpenTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.IntGetUserOpenTradesCountReply} returns this
 */
proto.analyticsmanager.IntGetUserOpenTradesCountReply.prototype.setOpenTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.ListTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.ListTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.ListTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 4, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0),
searchKey: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.ListTradesReq}
 */
proto.analyticsmanager.ListTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.ListTradesReq;
  return proto.analyticsmanager.ListTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.ListTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.ListTradesReq}
 */
proto.analyticsmanager.ListTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {!proto.analyticsmanager.TRADE_STATUS} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.ListTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.ListTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.ListTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getSearchKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.ListTradesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.ListTradesReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TRADE_STATUS status = 3;
 * @return {!proto.analyticsmanager.TRADE_STATUS}
 */
proto.analyticsmanager.ListTradesReq.prototype.getStatus = function() {
  return /** @type {!proto.analyticsmanager.TRADE_STATUS} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.analyticsmanager.TRADE_STATUS} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string pagination_cursor = 4;
 * @return {string}
 */
proto.analyticsmanager.ListTradesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 page_size = 5;
 * @return {number}
 */
proto.analyticsmanager.ListTradesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string search_key = 6;
 * @return {string}
 */
proto.analyticsmanager.ListTradesReq.prototype.getSearchKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListTradesReq} returns this
 */
proto.analyticsmanager.ListTradesReq.prototype.setSearchKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.ListTradesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.ListTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.ListTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.ListTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.analyticsmanager.TradeRes.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.ListTradesReply}
 */
proto.analyticsmanager.ListTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.ListTradesReply;
  return proto.analyticsmanager.ListTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.ListTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.ListTradesReply}
 */
proto.analyticsmanager.ListTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.TradeRes;
      reader.readMessage(value,proto.analyticsmanager.TradeRes.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.ListTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.ListTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.ListTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.TradeRes.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated TradeRes trades = 1;
 * @return {!Array<!proto.analyticsmanager.TradeRes>}
 */
proto.analyticsmanager.ListTradesReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.analyticsmanager.TradeRes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.TradeRes, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.TradeRes>} value
 * @return {!proto.analyticsmanager.ListTradesReply} returns this
*/
proto.analyticsmanager.ListTradesReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.TradeRes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.TradeRes}
 */
proto.analyticsmanager.ListTradesReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.TradeRes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.ListTradesReply} returns this
 */
proto.analyticsmanager.ListTradesReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.analyticsmanager.ListTradesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListTradesReply} returns this
 */
proto.analyticsmanager.ListTradesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.analyticsmanager.ListTradesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.ListTradesReply} returns this
 */
proto.analyticsmanager.ListTradesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.analyticsmanager.ListTradesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.ListTradesReply} returns this
 */
proto.analyticsmanager.ListTradesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.TradeRes.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.TradeRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.TradeRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.TradeRes.toObject = function(includeInstance, msg) {
  var f, obj = {
ticket: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
stopLoss: (f = msg.getStopLoss()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
openPrice: (f = msg.getOpenPrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
takeProfit: (f = msg.getTakeProfit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
profitLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
openTime: (f = msg.getOpenTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
closeTime: (f = msg.getCloseTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
accountId: jspb.Message.getFieldWithDefault(msg, 12, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 13, ""),
swap: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
commission: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
netPl: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 17, ""),
comment: jspb.Message.getFieldWithDefault(msg, 18, ""),
storage: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
closePrice: (f = msg.getClosePrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
nickName: jspb.Message.getFieldWithDefault(msg, 21, ""),
closeComment: (f = msg.getCloseComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
closeOrderId: (f = msg.getCloseOrderId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
closedLots: (f = msg.getClosedLots()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.TradeRes}
 */
proto.analyticsmanager.TradeRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.TradeRes;
  return proto.analyticsmanager.TradeRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.TradeRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.TradeRes}
 */
proto.analyticsmanager.TradeRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStopLoss(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOpenPrice(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTakeProfit(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitLoss(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpenTime(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCloseTime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSwap(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommission(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNetPl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStorage(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setClosePrice(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCloseComment(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setCloseOrderId(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setClosedLots(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.TradeRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.TradeRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.TradeRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.TradeRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getStopLoss();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOpenPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfit();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getOpenTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCloseTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSwap();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getCommission();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getNetPl();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getStorage();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getClosePrice();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCloseComment();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseOrderId();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getClosedLots();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticket = 1;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double lots = 5;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue stop_loss = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeRes.prototype.getStopLoss = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearStopLoss = function() {
  return this.setStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasStopLoss = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue open_price = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeRes.prototype.getOpenPrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setOpenPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearOpenPrice = function() {
  return this.setOpenPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasOpenPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue take_profit = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeRes.prototype.getTakeProfit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearTakeProfit = function() {
  return this.setTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasTakeProfit = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double profit_loss = 9;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getProfitLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setProfitLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp open_time = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyticsmanager.TradeRes.prototype.getOpenTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setOpenTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearOpenTime = function() {
  return this.setOpenTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasOpenTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp close_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyticsmanager.TradeRes.prototype.getCloseTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearCloseTime = function() {
  return this.setCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasCloseTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string account_id = 12;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string account_number = 13;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional double swap = 14;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getSwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setSwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double commission = 15;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getCommission = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setCommission = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double net_pl = 16;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getNetPl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setNetPl = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional string currency = 17;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string comment = 18;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional double storage = 19;
 * @return {number}
 */
proto.analyticsmanager.TradeRes.prototype.getStorage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setStorage = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional google.protobuf.StringValue close_price = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeRes.prototype.getClosePrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setClosePrice = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearClosePrice = function() {
  return this.setClosePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasClosePrice = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string nick_name = 21;
 * @return {string}
 */
proto.analyticsmanager.TradeRes.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional google.protobuf.StringValue close_comment = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeRes.prototype.getCloseComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setCloseComment = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearCloseComment = function() {
  return this.setCloseComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasCloseComment = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Int64Value close_order_id = 23;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.analyticsmanager.TradeRes.prototype.getCloseOrderId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 23));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setCloseOrderId = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearCloseOrderId = function() {
  return this.setCloseOrderId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasCloseOrderId = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.DoubleValue closed_lots = 24;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.analyticsmanager.TradeRes.prototype.getClosedLots = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 24));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setClosedLots = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearClosedLots = function() {
  return this.setClosedLots(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasClosedLots = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 25;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.analyticsmanager.TradeRes.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 25));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.analyticsmanager.TradeRes} returns this
*/
proto.analyticsmanager.TradeRes.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeRes} returns this
 */
proto.analyticsmanager.TradeRes.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeRes.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 25) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.GetBalanceInfoReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.GetBalanceInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.GetBalanceInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.GetBalanceInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.GetBalanceInfoReq}
 */
proto.analyticsmanager.GetBalanceInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.GetBalanceInfoReq;
  return proto.analyticsmanager.GetBalanceInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.GetBalanceInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.GetBalanceInfoReq}
 */
proto.analyticsmanager.GetBalanceInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.GetBalanceInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.GetBalanceInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.GetBalanceInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.GetBalanceInfoReq} returns this
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string accounts = 2;
 * @return {!Array<string>}
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyticsmanager.GetBalanceInfoReq} returns this
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.GetBalanceInfoReq} returns this
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.GetBalanceInfoReq} returns this
 */
proto.analyticsmanager.GetBalanceInfoReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.GetBalanceInfoReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.GetBalanceInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.GetBalanceInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.GetBalanceInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.GetBalanceInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
balancesList: jspb.Message.toObjectList(msg.getBalancesList(),
    proto.analyticsmanager.BalanceInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.GetBalanceInfoReply}
 */
proto.analyticsmanager.GetBalanceInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.GetBalanceInfoReply;
  return proto.analyticsmanager.GetBalanceInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.GetBalanceInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.GetBalanceInfoReply}
 */
proto.analyticsmanager.GetBalanceInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.BalanceInfo;
      reader.readMessage(value,proto.analyticsmanager.BalanceInfo.deserializeBinaryFromReader);
      msg.addBalances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.GetBalanceInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.GetBalanceInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.GetBalanceInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.GetBalanceInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.BalanceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BalanceInfo balances = 1;
 * @return {!Array<!proto.analyticsmanager.BalanceInfo>}
 */
proto.analyticsmanager.GetBalanceInfoReply.prototype.getBalancesList = function() {
  return /** @type{!Array<!proto.analyticsmanager.BalanceInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.BalanceInfo, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.BalanceInfo>} value
 * @return {!proto.analyticsmanager.GetBalanceInfoReply} returns this
*/
proto.analyticsmanager.GetBalanceInfoReply.prototype.setBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.BalanceInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.BalanceInfo}
 */
proto.analyticsmanager.GetBalanceInfoReply.prototype.addBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.BalanceInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.GetBalanceInfoReply} returns this
 */
proto.analyticsmanager.GetBalanceInfoReply.prototype.clearBalancesList = function() {
  return this.setBalancesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.BalanceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.BalanceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.BalanceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.BalanceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.BalanceInfo}
 */
proto.analyticsmanager.BalanceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.BalanceInfo;
  return proto.analyticsmanager.BalanceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.BalanceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.BalanceInfo}
 */
proto.analyticsmanager.BalanceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.BalanceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.BalanceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.BalanceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.BalanceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyticsmanager.BalanceInfo.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.BalanceInfo} returns this
 */
proto.analyticsmanager.BalanceInfo.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.analyticsmanager.BalanceInfo.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.BalanceInfo} returns this
 */
proto.analyticsmanager.BalanceInfo.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double equity = 3;
 * @return {number}
 */
proto.analyticsmanager.BalanceInfo.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.BalanceInfo} returns this
 */
proto.analyticsmanager.BalanceInfo.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.analyticsmanager.BalanceInfo.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.BalanceInfo} returns this
 */
proto.analyticsmanager.BalanceInfo.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountStatsReq}
 */
proto.analyticsmanager.AccountStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountStatsReq;
  return proto.analyticsmanager.AccountStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountStatsReq}
 */
proto.analyticsmanager.AccountStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AccountStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStatsReq} returns this
 */
proto.analyticsmanager.AccountStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.AccountStatsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStatsReq} returns this
 */
proto.analyticsmanager.AccountStatsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.AccountStatsReply.repeatedFields_ = [1,2,3,4,25,27];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
balanceDailyList: jspb.Message.toObjectList(msg.getBalanceDailyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
balanceMonthlyList: jspb.Message.toObjectList(msg.getBalanceMonthlyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
equityDailyList: jspb.Message.toObjectList(msg.getEquityDailyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
equityMonthlyList: jspb.Message.toObjectList(msg.getEquityMonthlyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
totalProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
openTrades: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalTradesTaken: jspb.Message.getFieldWithDefault(msg, 7, 0),
win: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
loss: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
longsWon: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
shortsWon: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
bestTrade: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
worstTrade: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
averageWin: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
averageLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
balanceDailyDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
balanceMonthlyDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
equityDailyDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
equityMonthlyDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
bestTradeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
worstTradeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 23, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 24, ""),
totalProfitYearlyList: jspb.Message.toObjectList(msg.getTotalProfitYearlyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
totalProfitYearlyDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
monthlyTradesTakenList: jspb.Message.toObjectList(msg.getMonthlyTradesTakenList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
monthlyTradesTakenDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
gainPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
absGain: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
absGainPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
roi: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
roiPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountStatsReply}
 */
proto.analyticsmanager.AccountStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountStatsReply;
  return proto.analyticsmanager.AccountStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountStatsReply}
 */
proto.analyticsmanager.AccountStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addBalanceDaily(value);
      break;
    case 2:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addBalanceMonthly(value);
      break;
    case 3:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addEquityDaily(value);
      break;
    case 4:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addEquityMonthly(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalProfit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTrades(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalTradesTaken(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWin(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLoss(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongsWon(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShortsWon(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTrade(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTrade(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageWin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageLoss(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalanceDailyDiff(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalanceMonthlyDiff(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquityDailyDiff(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquityMonthlyDiff(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTradeProfit(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTradeProfit(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 25:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addTotalProfitYearly(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalProfitYearlyDiff(value);
      break;
    case 27:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addMonthlyTradesTaken(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyTradesTakenDiff(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGainPercentage(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAbsGain(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAbsGainPercentage(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoi(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalanceDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMonthlyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getEquityDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getEquityMonthlyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getTotalProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getOpenTrades();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalTradesTaken();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getWin();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getLongsWon();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getShortsWon();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getBestTrade();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getWorstTrade();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getAverageWin();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getAverageLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBalanceDailyDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getBalanceMonthlyDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getEquityDailyDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getEquityMonthlyDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getBestTradeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getWorstTradeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getTotalProfitYearlyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      25,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getTotalProfitYearlyDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getMonthlyTradesTakenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getMonthlyTradesTakenDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getGainPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getAbsGain();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = message.getAbsGainPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getRoiPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
};


/**
 * repeated DateWiseData balance_daily = 1;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBalanceDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setBalanceDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addBalanceDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearBalanceDailyList = function() {
  return this.setBalanceDailyList([]);
};


/**
 * repeated DateWiseData balance_monthly = 2;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBalanceMonthlyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 2));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setBalanceMonthlyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addBalanceMonthly = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearBalanceMonthlyList = function() {
  return this.setBalanceMonthlyList([]);
};


/**
 * repeated DateWiseData equity_daily = 3;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getEquityDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 3));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setEquityDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addEquityDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearEquityDailyList = function() {
  return this.setEquityDailyList([]);
};


/**
 * repeated DateWiseData equity_monthly = 4;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getEquityMonthlyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 4));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setEquityMonthlyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addEquityMonthly = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearEquityMonthlyList = function() {
  return this.setEquityMonthlyList([]);
};


/**
 * optional double total_profit = 5;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getTotalProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setTotalProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 open_trades = 6;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getOpenTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setOpenTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 total_trades_taken = 7;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getTotalTradesTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setTotalTradesTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double win = 8;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getWin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setWin = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double loss = 9;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double longs_won = 10;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getLongsWon = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setLongsWon = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double shorts_won = 11;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getShortsWon = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setShortsWon = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double lots = 12;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double best_trade = 13;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBestTrade = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setBestTrade = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double worst_trade = 14;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getWorstTrade = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setWorstTrade = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double average_win = 15;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getAverageWin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setAverageWin = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double average_loss = 16;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getAverageLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setAverageLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double balance_daily_diff = 17;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBalanceDailyDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setBalanceDailyDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double balance_monthly_diff = 18;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBalanceMonthlyDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setBalanceMonthlyDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional double equity_daily_diff = 19;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getEquityDailyDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setEquityDailyDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double equity_monthly_diff = 20;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getEquityMonthlyDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setEquityMonthlyDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double best_trade_profit = 21;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getBestTradeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setBestTradeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional double worst_trade_profit = 22;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getWorstTradeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setWorstTradeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional string currency = 23;
 * @return {string}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string account_number = 24;
 * @return {string}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * repeated DateWiseData total_profit_yearly = 25;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getTotalProfitYearlyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 25));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setTotalProfitYearlyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 25, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addTotalProfitYearly = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearTotalProfitYearlyList = function() {
  return this.setTotalProfitYearlyList([]);
};


/**
 * optional double total_profit_yearly_diff = 26;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getTotalProfitYearlyDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setTotalProfitYearlyDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * repeated DateWiseIntData monthly_trades_taken = 27;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getMonthlyTradesTakenList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 27));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
*/
proto.analyticsmanager.AccountStatsReply.prototype.setMonthlyTradesTakenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.AccountStatsReply.prototype.addMonthlyTradesTaken = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.clearMonthlyTradesTakenList = function() {
  return this.setMonthlyTradesTakenList([]);
};


/**
 * optional double monthly_trades_taken_diff = 28;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getMonthlyTradesTakenDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setMonthlyTradesTakenDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double gain_percentage = 29;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getGainPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setGainPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional double abs_gain = 30;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getAbsGain = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setAbsGain = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double abs_gain_percentage = 31;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getAbsGainPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setAbsGainPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional double roi = 32;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional double roi_percentage = 33;
 * @return {number}
 */
proto.analyticsmanager.AccountStatsReply.prototype.getRoiPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStatsReply} returns this
 */
proto.analyticsmanager.AccountStatsReply.prototype.setRoiPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 33, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.CopierMetricsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.CopierMetricsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.CopierMetricsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.CopierMetricsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.CopierMetricsReq}
 */
proto.analyticsmanager.CopierMetricsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.CopierMetricsReq;
  return proto.analyticsmanager.CopierMetricsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.CopierMetricsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.CopierMetricsReq}
 */
proto.analyticsmanager.CopierMetricsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.CopierMetricsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.CopierMetricsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.CopierMetricsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.CopierMetricsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.CopierMetricsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.CopierMetricsReq} returns this
 */
proto.analyticsmanager.CopierMetricsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.analyticsmanager.CopierMetricsReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.CopierMetricsReq} returns this
 */
proto.analyticsmanager.CopierMetricsReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.CopierMetricsReply.repeatedFields_ = [1,2,3,4,10,11,12,13,22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.CopierMetricsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.CopierMetricsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.CopierMetricsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
portfolioDailyList: jspb.Message.toObjectList(msg.getPortfolioDailyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
masterAccountsDailyList: jspb.Message.toObjectList(msg.getMasterAccountsDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
slaveAccountsDailyList: jspb.Message.toObjectList(msg.getSlaveAccountsDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
tradesTakenDailyList: jspb.Message.toObjectList(msg.getTradesTakenDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
portfolioDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
masterAccountsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
tradesTakeDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
slavesDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
openTrades: jspb.Message.getFieldWithDefault(msg, 9, 0),
tradesCopiedDailyList: jspb.Message.toObjectList(msg.getTradesCopiedDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
tradesWonList: jspb.Message.toObjectList(msg.getTradesWonList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
tradesLossList: jspb.Message.toObjectList(msg.getTradesLossList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
winRateDailyList: jspb.Message.toObjectList(msg.getWinRateDailyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
winRateDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
tradesCopiedDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
bestTradeProfitPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
bestTradeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
worstTradeProfitPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
worstTradeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
yesterdaysOpenPositions: jspb.Message.getFieldWithDefault(msg, 20, 0),
openPositionsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
dailyPnlList: jspb.Message.toObjectList(msg.getDailyPnlList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
pnlDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.CopierMetricsReply}
 */
proto.analyticsmanager.CopierMetricsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.CopierMetricsReply;
  return proto.analyticsmanager.CopierMetricsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.CopierMetricsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.CopierMetricsReply}
 */
proto.analyticsmanager.CopierMetricsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addPortfolioDaily(value);
      break;
    case 2:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addMasterAccountsDaily(value);
      break;
    case 3:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addSlaveAccountsDaily(value);
      break;
    case 4:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addTradesTakenDaily(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPortfolioDiff(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMasterAccountsDiff(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradesTakeDiff(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSlavesDiff(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTrades(value);
      break;
    case 10:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addTradesCopiedDaily(value);
      break;
    case 11:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addTradesWon(value);
      break;
    case 12:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addTradesLoss(value);
      break;
    case 13:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addWinRateDaily(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWinRateDiff(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradesCopiedDiff(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTradeProfitPercentage(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTradeProfit(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTradeProfitPercentage(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTradeProfit(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setYesterdaysOpenPositions(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPositionsDiff(value);
      break;
    case 22:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addDailyPnl(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPnlDiff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.CopierMetricsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.CopierMetricsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.CopierMetricsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfolioDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountsDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getSlaveAccountsDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getTradesTakenDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getPortfolioDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMasterAccountsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTradesTakeDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getSlavesDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getOpenTrades();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getTradesCopiedDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getTradesWonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getTradesLossList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getWinRateDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getWinRateDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getTradesCopiedDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getBestTradeProfitPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBestTradeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getWorstTradeProfitPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getWorstTradeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getYesterdaysOpenPositions();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getOpenPositionsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getDailyPnlList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getPnlDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
};


/**
 * repeated DateWiseData portfolio_daily = 1;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getPortfolioDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setPortfolioDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addPortfolioDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearPortfolioDailyList = function() {
  return this.setPortfolioDailyList([]);
};


/**
 * repeated DateWiseIntData master_accounts_daily = 2;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getMasterAccountsDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 2));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setMasterAccountsDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addMasterAccountsDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearMasterAccountsDailyList = function() {
  return this.setMasterAccountsDailyList([]);
};


/**
 * repeated DateWiseIntData slave_accounts_daily = 3;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getSlaveAccountsDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 3));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setSlaveAccountsDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addSlaveAccountsDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearSlaveAccountsDailyList = function() {
  return this.setSlaveAccountsDailyList([]);
};


/**
 * repeated DateWiseIntData trades_taken_daily = 4;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesTakenDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 4));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesTakenDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addTradesTakenDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearTradesTakenDailyList = function() {
  return this.setTradesTakenDailyList([]);
};


/**
 * optional double portfolio_diff = 5;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getPortfolioDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setPortfolioDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double master_accounts_diff = 6;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getMasterAccountsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setMasterAccountsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double trades_take_diff = 7;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesTakeDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesTakeDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double slaves_diff = 8;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getSlavesDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setSlavesDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int64 open_trades = 9;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getOpenTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setOpenTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated DateWiseIntData trades_copied_daily = 10;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesCopiedDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 10));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesCopiedDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addTradesCopiedDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearTradesCopiedDailyList = function() {
  return this.setTradesCopiedDailyList([]);
};


/**
 * repeated DateWiseIntData trades_won = 11;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesWonList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 11));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesWonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addTradesWon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearTradesWonList = function() {
  return this.setTradesWonList([]);
};


/**
 * repeated DateWiseIntData trades_loss = 12;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesLossList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 12));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesLossList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addTradesLoss = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearTradesLossList = function() {
  return this.setTradesLossList([]);
};


/**
 * repeated DateWiseData win_rate_daily = 13;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getWinRateDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 13));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setWinRateDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addWinRateDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearWinRateDailyList = function() {
  return this.setWinRateDailyList([]);
};


/**
 * optional double win_rate_diff = 14;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getWinRateDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setWinRateDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double trades_copied_diff = 15;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getTradesCopiedDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setTradesCopiedDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double best_trade_profit_percentage = 16;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getBestTradeProfitPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setBestTradeProfitPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double best_trade_profit = 17;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getBestTradeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setBestTradeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double worst_trade_profit_percentage = 18;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getWorstTradeProfitPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setWorstTradeProfitPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional double worst_trade_profit = 19;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getWorstTradeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setWorstTradeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional int64 yesterdays_open_positions = 20;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getYesterdaysOpenPositions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setYesterdaysOpenPositions = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional double open_positions_diff = 21;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getOpenPositionsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setOpenPositionsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * repeated DateWiseData daily_pnl = 22;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getDailyPnlList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 22));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
*/
proto.analyticsmanager.CopierMetricsReply.prototype.setDailyPnlList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.addDailyPnl = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.clearDailyPnlList = function() {
  return this.setDailyPnlList([]);
};


/**
 * optional double pnl_diff = 23;
 * @return {number}
 */
proto.analyticsmanager.CopierMetricsReply.prototype.getPnlDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.CopierMetricsReply} returns this
 */
proto.analyticsmanager.CopierMetricsReply.prototype.setPnlDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.OverviewStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.OverviewStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.OverviewStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.OverviewStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.OverviewStatsReq}
 */
proto.analyticsmanager.OverviewStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.OverviewStatsReq;
  return proto.analyticsmanager.OverviewStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.OverviewStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.OverviewStatsReq}
 */
proto.analyticsmanager.OverviewStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.OverviewStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.OverviewStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.OverviewStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.OverviewStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.OverviewStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.OverviewStatsReq} returns this
 */
proto.analyticsmanager.OverviewStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.analyticsmanager.OverviewStatsReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.OverviewStatsReq} returns this
 */
proto.analyticsmanager.OverviewStatsReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.OverviewStatsReply.repeatedFields_ = [1,2,3,4,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.OverviewStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.OverviewStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.OverviewStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
portfolioDailyList: jspb.Message.toObjectList(msg.getPortfolioDailyList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
accountsConnectedDailyList: jspb.Message.toObjectList(msg.getAccountsConnectedDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
masterAccountsDailyList: jspb.Message.toObjectList(msg.getMasterAccountsDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
tradesTakenDailyList: jspb.Message.toObjectList(msg.getTradesTakenDailyList(),
    proto.analyticsmanager.DateWiseIntData.toObject, includeInstance),
portfolioDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
masterAccountsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
tradesTakeDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
accountsConnectedDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
openTrades: jspb.Message.getFieldWithDefault(msg, 9, 0),
slaveCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
accountsEnabledCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
totalOpenPl: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
totalClosedTrades: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
tradesWon: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
tradesLost: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
bestTradeProfitPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
bestTradeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
dailyPnlList: jspb.Message.toObjectList(msg.getDailyPnlList(),
    proto.analyticsmanager.DateWiseData.toObject, includeInstance),
pnlDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
worstTradeProfitPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
worstTradesProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.OverviewStatsReply}
 */
proto.analyticsmanager.OverviewStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.OverviewStatsReply;
  return proto.analyticsmanager.OverviewStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.OverviewStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.OverviewStatsReply}
 */
proto.analyticsmanager.OverviewStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addPortfolioDaily(value);
      break;
    case 2:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addAccountsConnectedDaily(value);
      break;
    case 3:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addMasterAccountsDaily(value);
      break;
    case 4:
      var value = new proto.analyticsmanager.DateWiseIntData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader);
      msg.addTradesTakenDaily(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPortfolioDiff(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMasterAccountsDiff(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradesTakeDiff(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccountsConnectedDiff(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTrades(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSlaveCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountsEnabledCount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalOpenPl(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalClosedTrades(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradesWon(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradesLost(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTradeProfitPercentage(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestTradeProfit(value);
      break;
    case 18:
      var value = new proto.analyticsmanager.DateWiseData;
      reader.readMessage(value,proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader);
      msg.addDailyPnl(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPnlDiff(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTradeProfitPercentage(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWorstTradesProfit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.OverviewStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.OverviewStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.OverviewStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfolioDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getAccountsConnectedDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountsDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getTradesTakenDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter
    );
  }
  f = message.getPortfolioDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMasterAccountsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTradesTakeDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getAccountsConnectedDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getOpenTrades();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getSlaveCount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAccountsEnabledCount();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getTotalOpenPl();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTotalClosedTrades();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getTradesWon();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getTradesLost();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getBestTradeProfitPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBestTradeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getDailyPnlList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.analyticsmanager.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getPnlDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getWorstTradeProfitPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getWorstTradesProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
};


/**
 * repeated DateWiseData portfolio_daily = 1;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getPortfolioDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
*/
proto.analyticsmanager.OverviewStatsReply.prototype.setPortfolioDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.addPortfolioDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.clearPortfolioDailyList = function() {
  return this.setPortfolioDailyList([]);
};


/**
 * repeated DateWiseIntData accounts_connected_daily = 2;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getAccountsConnectedDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 2));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
*/
proto.analyticsmanager.OverviewStatsReply.prototype.setAccountsConnectedDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.addAccountsConnectedDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.clearAccountsConnectedDailyList = function() {
  return this.setAccountsConnectedDailyList([]);
};


/**
 * repeated DateWiseIntData master_accounts_daily = 3;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getMasterAccountsDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 3));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
*/
proto.analyticsmanager.OverviewStatsReply.prototype.setMasterAccountsDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.addMasterAccountsDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.clearMasterAccountsDailyList = function() {
  return this.setMasterAccountsDailyList([]);
};


/**
 * repeated DateWiseIntData trades_taken_daily = 4;
 * @return {!Array<!proto.analyticsmanager.DateWiseIntData>}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTradesTakenDailyList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseIntData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseIntData, 4));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseIntData>} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
*/
proto.analyticsmanager.OverviewStatsReply.prototype.setTradesTakenDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseIntData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.addTradesTakenDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.analyticsmanager.DateWiseIntData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.clearTradesTakenDailyList = function() {
  return this.setTradesTakenDailyList([]);
};


/**
 * optional double portfolio_diff = 5;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getPortfolioDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setPortfolioDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double master_accounts_diff = 6;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getMasterAccountsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setMasterAccountsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double trades_take_diff = 7;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTradesTakeDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setTradesTakeDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double accounts_connected_diff = 8;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getAccountsConnectedDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setAccountsConnectedDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int64 open_trades = 9;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getOpenTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setOpenTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 slave_count = 10;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getSlaveCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setSlaveCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 accounts_enabled_count = 11;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getAccountsEnabledCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setAccountsEnabledCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double total_open_pl = 12;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTotalOpenPl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setTotalOpenPl = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double total_closed_trades = 13;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTotalClosedTrades = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setTotalClosedTrades = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double trades_won = 14;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTradesWon = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setTradesWon = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double trades_lost = 15;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getTradesLost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setTradesLost = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double best_trade_profit_percentage = 16;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getBestTradeProfitPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setBestTradeProfitPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double best_trade_profit = 17;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getBestTradeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setBestTradeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * repeated DateWiseData daily_pnl = 18;
 * @return {!Array<!proto.analyticsmanager.DateWiseData>}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getDailyPnlList = function() {
  return /** @type{!Array<!proto.analyticsmanager.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.DateWiseData, 18));
};


/**
 * @param {!Array<!proto.analyticsmanager.DateWiseData>} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
*/
proto.analyticsmanager.OverviewStatsReply.prototype.setDailyPnlList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.analyticsmanager.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.addDailyPnl = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.analyticsmanager.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.clearDailyPnlList = function() {
  return this.setDailyPnlList([]);
};


/**
 * optional double pnl_diff = 19;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getPnlDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setPnlDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double worst_trade_profit_percentage = 20;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getWorstTradeProfitPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setWorstTradeProfitPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double worst_trades_profit = 21;
 * @return {number}
 */
proto.analyticsmanager.OverviewStatsReply.prototype.getWorstTradesProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.OverviewStatsReply} returns this
 */
proto.analyticsmanager.OverviewStatsReply.prototype.setWorstTradesProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.DateWiseData.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.DateWiseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.DateWiseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.DateWiseData.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.DateWiseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.DateWiseData;
  return proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.DateWiseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.DateWiseData}
 */
proto.analyticsmanager.DateWiseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.DateWiseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.DateWiseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.DateWiseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.DateWiseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyticsmanager.DateWiseData.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.DateWiseData} returns this
 */
proto.analyticsmanager.DateWiseData.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.analyticsmanager.DateWiseData.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.DateWiseData} returns this
 */
proto.analyticsmanager.DateWiseData.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.DateWiseIntData.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.DateWiseIntData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.DateWiseIntData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.DateWiseIntData.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.DateWiseIntData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.DateWiseIntData;
  return proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.DateWiseIntData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.DateWiseIntData}
 */
proto.analyticsmanager.DateWiseIntData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.DateWiseIntData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.DateWiseIntData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.DateWiseIntData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyticsmanager.DateWiseIntData.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.DateWiseIntData} returns this
 */
proto.analyticsmanager.DateWiseIntData.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 value = 2;
 * @return {number}
 */
proto.analyticsmanager.DateWiseIntData.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.DateWiseIntData} returns this
 */
proto.analyticsmanager.DateWiseIntData.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.ListAccountStatsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.ListAccountStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.ListAccountStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListAccountStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.ListAccountStatsReq}
 */
proto.analyticsmanager.ListAccountStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.ListAccountStatsReq;
  return proto.analyticsmanager.ListAccountStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.ListAccountStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.ListAccountStatsReq}
 */
proto.analyticsmanager.ListAccountStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccountIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.ListAccountStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.ListAccountStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListAccountStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.ListAccountStatsReq} returns this
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string account_ids = 2;
 * @return {!Array<string>}
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.getAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyticsmanager.ListAccountStatsReq} returns this
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.ListAccountStatsReq} returns this
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.ListAccountStatsReq} returns this
 */
proto.analyticsmanager.ListAccountStatsReq.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.ListAccountStatsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.ListAccountStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.ListAccountStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.ListAccountStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListAccountStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountListList: jspb.Message.toObjectList(msg.getAccountListList(),
    proto.analyticsmanager.AccountStat.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.ListAccountStatsReply}
 */
proto.analyticsmanager.ListAccountStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.ListAccountStatsReply;
  return proto.analyticsmanager.ListAccountStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.ListAccountStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.ListAccountStatsReply}
 */
proto.analyticsmanager.ListAccountStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.AccountStat;
      reader.readMessage(value,proto.analyticsmanager.AccountStat.deserializeBinaryFromReader);
      msg.addAccountList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.ListAccountStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.ListAccountStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.ListAccountStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.ListAccountStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.AccountStat.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountStat account_list = 1;
 * @return {!Array<!proto.analyticsmanager.AccountStat>}
 */
proto.analyticsmanager.ListAccountStatsReply.prototype.getAccountListList = function() {
  return /** @type{!Array<!proto.analyticsmanager.AccountStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.AccountStat, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.AccountStat>} value
 * @return {!proto.analyticsmanager.ListAccountStatsReply} returns this
*/
proto.analyticsmanager.ListAccountStatsReply.prototype.setAccountListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.AccountStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.AccountStat}
 */
proto.analyticsmanager.ListAccountStatsReply.prototype.addAccountList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.AccountStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.ListAccountStatsReply} returns this
 */
proto.analyticsmanager.ListAccountStatsReply.prototype.clearAccountListList = function() {
  return this.setAccountListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountStat.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStat.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
openTrades: jspb.Message.getFieldWithDefault(msg, 4, 0),
profitToday: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
profitThisWeek: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
profitThisMonth: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
profitAllTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
currency: jspb.Message.getFieldWithDefault(msg, 9, ""),
openPl: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountStat}
 */
proto.analyticsmanager.AccountStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountStat;
  return proto.analyticsmanager.AccountStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountStat}
 */
proto.analyticsmanager.AccountStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTrades(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitToday(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitThisWeek(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitThisMonth(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitAllTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getOpenTrades();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getProfitToday();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getProfitThisWeek();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getProfitThisMonth();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getProfitAllTime();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOpenPl();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AccountStat.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double equity = 3;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int64 open_trades = 4;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getOpenTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setOpenTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double profit_today = 5;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getProfitToday = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setProfitToday = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double profit_this_week = 6;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getProfitThisWeek = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setProfitThisWeek = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double profit_this_month = 7;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getProfitThisMonth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setProfitThisMonth = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double profit_all_time = 8;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getProfitAllTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setProfitAllTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional string currency = 9;
 * @return {string}
 */
proto.analyticsmanager.AccountStat.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double open_pl = 10;
 * @return {number}
 */
proto.analyticsmanager.AccountStat.prototype.getOpenPl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.AccountStat} returns this
 */
proto.analyticsmanager.AccountStat.prototype.setOpenPl = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntAddAnalyticsUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntAddAnalyticsUserReq}
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntAddAnalyticsUserReq;
  return proto.analyticsmanager.IntAddAnalyticsUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntAddAnalyticsUserReq}
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntAddAnalyticsUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntAddAnalyticsUserReq} returns this
 */
proto.analyticsmanager.IntAddAnalyticsUserReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntAddAnalyticsUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntAddAnalyticsUserReply}
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntAddAnalyticsUserReply;
  return proto.analyticsmanager.IntAddAnalyticsUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntAddAnalyticsUserReply}
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntAddAnalyticsUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntAddAnalyticsUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntAddAnalyticsUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetMasterTradesReq.repeatedFields_ = [1,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetMasterTradesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetMasterTradesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetMasterTradesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
mastersList: jspb.Message.toObjectList(msg.getMastersList(),
    proto.analyticsmanager.MasterMeta.toObject, includeInstance),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
searchNumber: (f = msg.getSearchNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
additionalTradesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq}
 */
proto.analyticsmanager.IntGetMasterTradesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetMasterTradesReq;
  return proto.analyticsmanager.IntGetMasterTradesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetMasterTradesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq}
 */
proto.analyticsmanager.IntGetMasterTradesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.MasterMeta;
      reader.readMessage(value,proto.analyticsmanager.MasterMeta.deserializeBinaryFromReader);
      msg.addMasters(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdditionalTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetMasterTradesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetMasterTradesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetMasterTradesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMastersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.MasterMeta.serializeBinaryToWriter
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSearchNumber();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalTradesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * repeated MasterMeta masters = 1;
 * @return {!Array<!proto.analyticsmanager.MasterMeta>}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.getMastersList = function() {
  return /** @type{!Array<!proto.analyticsmanager.MasterMeta>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.MasterMeta, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.MasterMeta>} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
*/
proto.analyticsmanager.IntGetMasterTradesReq.prototype.setMastersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.MasterMeta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.MasterMeta}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.addMasters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.MasterMeta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.clearMastersList = function() {
  return this.setMastersList([]);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue search_number = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.getSearchNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
*/
proto.analyticsmanager.IntGetMasterTradesReq.prototype.setSearchNumber = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.clearSearchNumber = function() {
  return this.setSearchNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.hasSearchNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string additional_trades = 5;
 * @return {!Array<string>}
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.getAdditionalTradesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.setAdditionalTradesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.addAdditionalTrades = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReq} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReq.prototype.clearAdditionalTradesList = function() {
  return this.setAdditionalTradesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetMasterTradesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetMasterTradesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetMasterTradesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetMasterTradesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.analyticsmanager.TradeDetails.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply}
 */
proto.analyticsmanager.IntGetMasterTradesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetMasterTradesReply;
  return proto.analyticsmanager.IntGetMasterTradesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetMasterTradesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply}
 */
proto.analyticsmanager.IntGetMasterTradesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.TradeDetails;
      reader.readMessage(value,proto.analyticsmanager.TradeDetails.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetMasterTradesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetMasterTradesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetMasterTradesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.TradeDetails.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated TradeDetails trades = 1;
 * @return {!Array<!proto.analyticsmanager.TradeDetails>}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.analyticsmanager.TradeDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.TradeDetails, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.TradeDetails>} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply} returns this
*/
proto.analyticsmanager.IntGetMasterTradesReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.TradeDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.TradeDetails}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.TradeDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.IntGetMasterTradesReply} returns this
 */
proto.analyticsmanager.IntGetMasterTradesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AccountTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AccountTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AccountTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
ticket: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AccountTicket}
 */
proto.analyticsmanager.AccountTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AccountTicket;
  return proto.analyticsmanager.AccountTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AccountTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AccountTicket}
 */
proto.analyticsmanager.AccountTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AccountTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AccountTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AccountTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AccountTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AccountTicket.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountTicket} returns this
 */
proto.analyticsmanager.AccountTicket.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticket = 2;
 * @return {string}
 */
proto.analyticsmanager.AccountTicket.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AccountTicket} returns this
 */
proto.analyticsmanager.AccountTicket.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetTradeDetailsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTradeDetailsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeDetailsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountTicketsList: jspb.Message.toObjectList(msg.getAccountTicketsList(),
    proto.analyticsmanager.AccountTicket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReq}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTradeDetailsReq;
  return proto.analyticsmanager.IntGetTradeDetailsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReq}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.AccountTicket;
      reader.readMessage(value,proto.analyticsmanager.AccountTicket.deserializeBinaryFromReader);
      msg.addAccountTickets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTradeDetailsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeDetailsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.AccountTicket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountTicket account_tickets = 1;
 * @return {!Array<!proto.analyticsmanager.AccountTicket>}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.getAccountTicketsList = function() {
  return /** @type{!Array<!proto.analyticsmanager.AccountTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.AccountTicket, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.AccountTicket>} value
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReq} returns this
*/
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.setAccountTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.AccountTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.AccountTicket}
 */
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.addAccountTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.AccountTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReq} returns this
 */
proto.analyticsmanager.IntGetTradeDetailsReq.prototype.clearAccountTicketsList = function() {
  return this.setAccountTicketsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetTradeDetailsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTradeDetailsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeDetailsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.analyticsmanager.TradeDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReply}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTradeDetailsReply;
  return proto.analyticsmanager.IntGetTradeDetailsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReply}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.TradeDetails;
      reader.readMessage(value,proto.analyticsmanager.TradeDetails.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTradeDetailsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTradeDetailsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeDetailsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.TradeDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradeDetails trades = 1;
 * @return {!Array<!proto.analyticsmanager.TradeDetails>}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.analyticsmanager.TradeDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.TradeDetails, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.TradeDetails>} value
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReply} returns this
*/
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.TradeDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.TradeDetails}
 */
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.TradeDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetTradeDetailsReply} returns this
 */
proto.analyticsmanager.IntGetTradeDetailsReply.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.TradeDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.TradeDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.TradeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.TradeDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
ticket: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
stopLoss: (f = msg.getStopLoss()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
openPrice: (f = msg.getOpenPrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
takeProfit: (f = msg.getTakeProfit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
profitLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
openTime: (f = msg.getOpenTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
closeTime: (f = msg.getCloseTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
accountId: jspb.Message.getFieldWithDefault(msg, 13, ""),
swap: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
commission: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
comment: jspb.Message.getFieldWithDefault(msg, 16, ""),
closePrice: (f = msg.getClosePrice()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
storage: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
closeComment: (f = msg.getCloseComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
closeOrderId: (f = msg.getCloseOrderId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.TradeDetails}
 */
proto.analyticsmanager.TradeDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.TradeDetails;
  return proto.analyticsmanager.TradeDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.TradeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.TradeDetails}
 */
proto.analyticsmanager.TradeDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStopLoss(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOpenPrice(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTakeProfit(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitLoss(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpenTime(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCloseTime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSwap(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommission(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setClosePrice(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStorage(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCloseComment(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setCloseOrderId(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.TradeDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.TradeDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.TradeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.TradeDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getStopLoss();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOpenPrice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfit();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getOpenTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCloseTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSwap();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getCommission();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getClosePrice();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStorage();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getCloseComment();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseOrderId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ticket = 2;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_number = 4;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double lots = 6;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue stop_loss = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeDetails.prototype.getStopLoss = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearStopLoss = function() {
  return this.setStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasStopLoss = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue open_price = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeDetails.prototype.getOpenPrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setOpenPrice = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearOpenPrice = function() {
  return this.setOpenPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasOpenPrice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue take_profit = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeDetails.prototype.getTakeProfit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearTakeProfit = function() {
  return this.setTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasTakeProfit = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional double profit_loss = 10;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getProfitLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setProfitLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp open_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyticsmanager.TradeDetails.prototype.getOpenTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setOpenTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearOpenTime = function() {
  return this.setOpenTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasOpenTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp close_time = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyticsmanager.TradeDetails.prototype.getCloseTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearCloseTime = function() {
  return this.setCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasCloseTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string account_id = 13;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional double swap = 14;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getSwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setSwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double commission = 15;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getCommission = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setCommission = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional string comment = 16;
 * @return {string}
 */
proto.analyticsmanager.TradeDetails.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.StringValue close_price = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeDetails.prototype.getClosePrice = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setClosePrice = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearClosePrice = function() {
  return this.setClosePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasClosePrice = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional double storage = 18;
 * @return {number}
 */
proto.analyticsmanager.TradeDetails.prototype.getStorage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.setStorage = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional google.protobuf.StringValue close_comment = 19;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.analyticsmanager.TradeDetails.prototype.getCloseComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 19));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setCloseComment = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearCloseComment = function() {
  return this.setCloseComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasCloseComment = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.Int64Value close_order_id = 20;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.analyticsmanager.TradeDetails.prototype.getCloseOrderId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 20));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setCloseOrderId = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearCloseOrderId = function() {
  return this.setCloseOrderId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasCloseOrderId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 21;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.analyticsmanager.TradeDetails.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 21));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.analyticsmanager.TradeDetails} returns this
*/
proto.analyticsmanager.TradeDetails.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.TradeDetails} returns this
 */
proto.analyticsmanager.TradeDetails.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.TradeDetails.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 21) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTradeAccountStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReq}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTradeAccountStatsReq;
  return proto.analyticsmanager.IntGetTradeAccountStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReq}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTradeAccountStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string accounts = 1;
 * @return {!Array<string>}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReq} returns this
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReq} returns this
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReq} returns this
 */
proto.analyticsmanager.IntGetTradeAccountStatsReq.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetTradeAccountStatsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountStatMapMap: (f = msg.getAccountStatMapMap()) ? f.toObject(includeInstance, proto.analyticsmanager.AccountStat.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReply}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetTradeAccountStatsReply;
  return proto.analyticsmanager.IntGetTradeAccountStatsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReply}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getAccountStatMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.analyticsmanager.AccountStat.deserializeBinaryFromReader, "", new proto.analyticsmanager.AccountStat());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetTradeAccountStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetTradeAccountStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountStatMapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.analyticsmanager.AccountStat.serializeBinaryToWriter);
  }
};


/**
 * map<string, AccountStat> account_stat_map = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.analyticsmanager.AccountStat>}
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.prototype.getAccountStatMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.analyticsmanager.AccountStat>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.analyticsmanager.AccountStat));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.analyticsmanager.IntGetTradeAccountStatsReply} returns this
 */
proto.analyticsmanager.IntGetTradeAccountStatsReply.prototype.clearAccountStatMapMap = function() {
  this.getAccountStatMapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
considerOnPortfolio: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq;
  return proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsiderOnPortfolio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConsiderOnPortfolio();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} returns this
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} returns this
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool consider_on_portfolio = 3;
 * @return {boolean}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.getConsiderOnPortfolio = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq} returns this
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReq.prototype.setConsiderOnPortfolio = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply;
  return proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntUpdateConsiderAccountOnPortfolioReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq;
  return proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq} returns this
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq} returns this
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.toObject = function(includeInstance, msg) {
  var f, obj = {
considerOnPortfolio: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply;
  return proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsiderOnPortfolio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConsiderOnPortfolio();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool consider_on_portfolio = 1;
 * @return {boolean}
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.prototype.getConsiderOnPortfolio = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply} returns this
 */
proto.analyticsmanager.IntGetConsiderAccountOnPortfolioReply.prototype.setConsiderOnPortfolio = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.MasterMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.MasterMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.MasterMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.MasterMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.MasterMeta}
 */
proto.analyticsmanager.MasterMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.MasterMeta;
  return proto.analyticsmanager.MasterMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.MasterMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.MasterMeta}
 */
proto.analyticsmanager.MasterMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.MasterMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.MasterMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.MasterMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.MasterMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyticsmanager.MasterMeta.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.MasterMeta} returns this
 */
proto.analyticsmanager.MasterMeta.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyticsmanager.MasterMeta.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyticsmanager.MasterMeta} returns this
*/
proto.analyticsmanager.MasterMeta.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyticsmanager.MasterMeta} returns this
 */
proto.analyticsmanager.MasterMeta.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyticsmanager.MasterMeta.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminSyncAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminSyncAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminSyncAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminSyncAccountReq}
 */
proto.analyticsmanager.AdminSyncAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminSyncAccountReq;
  return proto.analyticsmanager.AdminSyncAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminSyncAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminSyncAccountReq}
 */
proto.analyticsmanager.AdminSyncAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminSyncAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminSyncAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminSyncAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminSyncAccountReq} returns this
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminSyncAccountReq} returns this
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyticsmanager.AdminSyncAccountReq} returns this
 */
proto.analyticsmanager.AdminSyncAccountReq.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.AdminSyncAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.AdminSyncAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.AdminSyncAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminSyncAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.AdminSyncAccountReply}
 */
proto.analyticsmanager.AdminSyncAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.AdminSyncAccountReply;
  return proto.analyticsmanager.AdminSyncAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.AdminSyncAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.AdminSyncAccountReply}
 */
proto.analyticsmanager.AdminSyncAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.AdminSyncAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.AdminSyncAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.AdminSyncAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.AdminSyncAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetOpenTradeTicketsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReq}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetOpenTradeTicketsReq;
  return proto.analyticsmanager.IntGetOpenTradeTicketsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReq}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccountIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetOpenTradeTicketsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string account_ids = 1;
 * @return {!Array<string>}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.getAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} returns this
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} returns this
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReq} returns this
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReq.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyticsmanager.IntGetOpenTradeTicketsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
openTicketsList: jspb.Message.toObjectList(msg.getOpenTicketsList(),
    proto.analyticsmanager.AccountTicket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReply}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyticsmanager.IntGetOpenTradeTicketsReply;
  return proto.analyticsmanager.IntGetOpenTradeTicketsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReply}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyticsmanager.AccountTicket;
      reader.readMessage(value,proto.analyticsmanager.AccountTicket.deserializeBinaryFromReader);
      msg.addOpenTickets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyticsmanager.IntGetOpenTradeTicketsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyticsmanager.IntGetOpenTradeTicketsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpenTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyticsmanager.AccountTicket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountTicket open_tickets = 1;
 * @return {!Array<!proto.analyticsmanager.AccountTicket>}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.getOpenTicketsList = function() {
  return /** @type{!Array<!proto.analyticsmanager.AccountTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyticsmanager.AccountTicket, 1));
};


/**
 * @param {!Array<!proto.analyticsmanager.AccountTicket>} value
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReply} returns this
*/
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.setOpenTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyticsmanager.AccountTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyticsmanager.AccountTicket}
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.addOpenTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyticsmanager.AccountTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyticsmanager.IntGetOpenTradeTicketsReply} returns this
 */
proto.analyticsmanager.IntGetOpenTradeTicketsReply.prototype.clearOpenTicketsList = function() {
  return this.setOpenTicketsList([]);
};


/**
 * @enum {number}
 */
proto.analyticsmanager.TRADE_STATUS = {
  UNKNOWN: 0,
  OPEN: 1,
  CLOSED: 2
};

goog.object.extend(exports, proto.analyticsmanager);
